import type { SvgIconComponent } from "@mui/icons-material";

import {
  AssignmentRounded,
  CalendarMonthRounded,
  CleaningServicesRounded,
  DescriptionRounded,
  LocationOnRounded,
  PaymentsRounded,
} from "@mui/icons-material";

import type { InvoiceIconName } from "../types/invoiceCustomStyle.types";

export const invoiceIconRegistry: Record<Exclude<InvoiceIconName, "none" | "default">, SvgIconComponent> = {
  calendar: CalendarMonthRounded,
  cleaning: CleaningServicesRounded,
  document: DescriptionRounded,
  location: LocationOnRounded,
  assignment: AssignmentRounded,
  payment: PaymentsRounded,
};

export const getInvoiceIcon = (iconName: InvoiceIconName, fallbackIcon: SvgIconComponent): SvgIconComponent | null => {
  if (iconName === "none") {
    return null;
  }

  if (iconName === "default") {
    return fallbackIcon;
  }

  return invoiceIconRegistry[iconName] ?? fallbackIcon;
};
